import { useGlobalStore } from '@/stores/global';
import { useLocaleStore } from '@/stores/locales';
import { computed, type App } from 'vue';
import { storeToRefs } from 'pinia';
import { siteAvailableLangs, type AppsUrls, type SiteUrls } from '@/plugins/env-urls/types';
import { SITE_URLS } from './site-urls';

export default {
  install: (app: App) => {
    const { currentLang } = storeToRefs(useLocaleStore());

    const appsUrls = computed(() => useGlobalStore().apps_urls);
    const lang = computed(() => {
      return siteAvailableLangs.includes(currentLang.value) ? currentLang.value : 'en';
    });

    function siteUrl(key: Exclude<keyof SiteUrls, 'base_url'>) {
      return `${SITE_URLS.base_url}/${lang.value}/${SITE_URLS[key][lang.value]}`;
    }

    function appUrl(key: keyof AppsUrls) {
      return appsUrls.value?.[key];
    }

    app.config.globalProperties.$siteUrl = siteUrl;
    app.config.globalProperties.$appUrl = appUrl;

    app.provide('siteUrl', siteUrl);
    app.provide('appUrl', appUrl);
  },
};
